import {Box} from '@mui/material';
import {IconName} from '@wandb/weave/components/Icon';
import React from 'react';

import {FieldLabel} from './components';
import {BORDER_COLOR, HEADER_HEIGHT_PX} from './constants';

export const ConfigSection: React.FC<{
  title: string;
  icon: IconName;
  style?: React.CSSProperties;
  children?: React.ReactNode;
  headerAction?: React.ReactNode;
}> = ({title, icon, style, children, headerAction}) => {
  return (
    <Column
      style={{
        flex: 0,
        padding: '16px',
        borderBottom: `1px solid ${BORDER_COLOR}`,
        ...style,
      }}>
      <Row
        style={{
          alignItems: 'center',
          flex: 0,
          fontWeight: 600,
          marginBottom: '8px',
          justifyContent: 'space-between',
        }}>
        <Row style={{alignItems: 'center', gap: '4px', margin: 0}}>
          <FieldLabel label={title} icon={icon} />
        </Row>
        {headerAction && <div style={{marginLeft: 'auto'}}>{headerAction}</div>}
      </Row>
      <div style={{display: 'flex', flexDirection: 'column', gap: '16px'}}>
        {children}
      </div>
    </Column>
  );
};

export const Header: React.FC<{children?: React.ReactNode}> = ({children}) => {
  return (
    <div
      style={{
        height: HEADER_HEIGHT_PX,
        borderBottom: `1px solid ${BORDER_COLOR}`,
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px',
        fontWeight: 600,
        fontSize: '18px',
        justifyContent: 'space-between',
        flex: `0 0 ${HEADER_HEIGHT_PX}px`,
      }}>
      {children}
    </div>
  );
};

export const Footer: React.FC<{children?: React.ReactNode}> = ({children}) => {
  return (
    <div
      style={{
        height: HEADER_HEIGHT_PX,
        borderTop: `1px solid ${BORDER_COLOR}`,
        display: 'flex',
        alignItems: 'center',
        padding: '0 16px',
        fontWeight: 600,
        fontSize: '18px',
        justifyContent: 'flex-end',
      }}>
      {children}
    </div>
  );
};

export const Row: React.FC<{
  style?: React.CSSProperties;
  children?: React.ReactNode;
}> = ({style, children}) => {
  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        flex: 1,
        ...style,
      }}>
      {children}
    </Box>
  );
};

export const Column: React.FC<{
  style?: React.CSSProperties;
  children?: React.ReactNode;
}> = ({style, children}) => {
  return (
    <Box
      style={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        flex: 1,
        ...style,
      }}>
      {children}
    </Box>
  );
};
